import { gql, useQuery } from '@apollo/client';

import { NexoyaQuery, NexoyaQueryPortfolioV2Args } from '../../types/types';
import { useTeam } from '../../context/TeamProvider';

import { PROVIDER_LABELS_FRAGMENT } from './fragments';

const LABELS_QUERY = gql`
  query Labels($teamId: Int!, $portfolioId: Int!) {
    portfolioV2(teamId: $teamId, portfolioId: $portfolioId) {
      labels {
        ...labels
      }
    }
  }
  ${PROVIDER_LABELS_FRAGMENT}
`;

function useLabelsQuery({
  portfolioId,
  onCompleted,
  skip = false,
}: {
  portfolioId: number;
  onCompleted?: (data: any) => void;
  skip?: boolean;
}) {
  const { teamId } = useTeam();
  return useQuery<Pick<NexoyaQuery, 'portfolioV2'>, NexoyaQueryPortfolioV2Args>(LABELS_QUERY, {
    skip: skip || !teamId || !portfolioId,
    onCompleted,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      teamId: teamId || null,
      portfolioId: portfolioId || null,
    },
  });
}

export { LABELS_QUERY, useLabelsQuery };
